const listStylePosition = {
  name: "list-style-position",
  path: "/list-style-position",
  title: "list-style-position",
  description: "Utilities for controlling the position of list markers.",
  value: {
    "list-style-position": {
      "list-inside": "inside",
      "list-outside": "outside"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<ul class="list-inside">
  <li>List marker is inside</li>
  <li>Another item</li>
</ul>
<ul class="list-outside">
  <li>List marker is outside</li>
  <li>Another item</li>
</ul>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">list-inside</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">list-outside</code> to control the position of list markers.
      </p>
      <div class="space-y-6">
        <div class="relative before:content-[] before:absolute before:block before:w-[1px] before:h-full before:bg-color-red-300">
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-inside</small>
          <ul class="list-inside list-disc">
            <li>List marker is inside</li>
            <li>Another item</li>
          </ul>
        </div>
        <div class="relative before:content-[] before:absolute before:block before:w-[1px] before:h-full before:bg-color-red-300">
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">list-outside</small>
          <ul class="list-outside list-disc">
            <li>List marker is outside</li>
            <li>Another item</li>
          </ul>
        </div>
      </div>
      `
    }
  ]
}
export default listStylePosition;

<div className="list-inside list-outside list-disc before:absolute before:content-[] before:block before:w-[1px] before:h-full before:bg-color-red-300"></div>